export default __webpack_public_path__ + "static/media/Add.72c3eb1c.svg";